import React, { useEffect } from 'react';
import useStyles from './styles';
import NavigationActions from 'redux/reducers/gl_navigation_reducer/actions';
import { useDispatch } from 'react-redux';
import * as NavigationSelectors from 'redux/reducers/gl_navigation_reducer/selectors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Searchbar from 'components/atoms/Searchbar';
import BaseNavigationMenu from 'components/app_common/BaseNavigationMenu';
import { Box, Typography } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import NavigationConfig from 'navigation/config';
import { TranslationKey } from '../configuration';
import RegitrationForm from 'components/compounds/RegistrationForm';
import Badge from '@material-ui/core/Badge';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import AppButton from 'components/atoms/Button';
import Link from '@material-ui/core/Link';
import FacebookIcon from '@material-ui/icons/Facebook';
import { GoogleIcon } from 'components/atoms/Icons/GoogleIcon';
import AppleIcon from '@material-ui/icons/Apple';
import { useHistory } from 'react-router';
import LoginForm from 'components/compounds/LoginForm';
import { socialLogin } from 'services/api/authenticate';
import useQuery from 'hooks/useQuery';

const RegisterOrLoginMenu = () => {
  const classes = useStyles();
  const history = useHistory();
  const [type, setType] = React.useState<'register' | 'login' | null>(null);
  const query = useQuery();
  const queryType: any = query.get('type');
  useEffect(() => {
    if (queryType) {
      setType(queryType);
    } else {
      type && setType(null);
    }
  }, [queryType]);
  const Menu = React.useMemo(
    () => (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        // margin="2rem"
        style={{ textAlign: 'center' }}
      >
        <div style={{ marginBottom: '1rem' }}>
          <Typography style={{ fontSize: 24, fontWeight: 700 }}>
            <TranslatedTextV2
              defaultText="Create your account"
              translationKey={`${TranslationKey}.createYourAccountTitle`}
            />
          </Typography>
          <Typography>
            <TranslatedTextV2
              defaultText="Sign-up with your email"
              translationKey={`${TranslationKey}.createYourAccountDescription`}
            />
          </Typography>
        </div>
        <AppButton
          text={
            <TranslatedTextV2
              defaultText="Create an account"
              translationKey={`${TranslationKey}.signupWithEmail`}
            />
          }
          onClick={() => setType('register')}
          color="primary"
          className={classes.authButton}
          fullWidth
        />
        {/* <Typography
          style={{
            fontWeight: 400,
            fontSize: 13.5,
            marginBottom: '1rem',
            marginTop: '3.5rem',
          }}
        >
          <TranslatedTextV2
            defaultText="Alternatively, use one of these methods to sign up"
            translationKey={`${TranslationKey}.alternatively`}
          />
        </Typography> */}
        {/* <AppButton
          text={
            <TranslatedTextV2
              defaultText="Sign up with Apple"
              translationKey={`${TranslationKey}.signupWithApple`}
            />
          }
          startIcon={<AppleIcon />}
          className={classes.authButton}
          style={{ background: 'black' }}
          fullWidth
        /> */}
        {/* <AppButton
          onClick={() => socialLogin('facebook')}
          text={
            <TranslatedTextV2
              defaultText="Sign up with Facebook"
              translationKey={`${TranslationKey}.signupWithFacebook`}
            />
          }
          startIcon={<FacebookIcon />}
          className={classes.authButton}
          fullWidth
        /> */}
        {/* <AppButton
          onClick={() => socialLogin('google')}
          startIcon={<GoogleIcon />}
          text={
            <TranslatedTextV2
              defaultText="Sign up with Google"
              translationKey={`${TranslationKey}.signupWithGoogle`}
            />
          }
          variant="outlined"
          color="default"
          className={classes.authButton}
          fullWidth
        /> */}
        <Box
          style={{ marginTop: '2rem' }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography style={{ marginRight: '0.5rem' }}>
            <TranslatedTextV2
              defaultText="Have an account?"
              translationKey={`${TranslationKey}.haveAccount`}
            />
          </Typography>
          <Link
            onClick={() => setType('login')}
            style={{ fontSize: 16, cursor: 'pointer' }}
            // href={history.push(NavigationConfig.loginPage().path}
          >
            <TranslatedTextV2
              defaultText="Log in"
              translationKey={`${TranslationKey}.loginIn`}
            />
          </Link>
        </Box>
        <div className={classes.toolbar} />
      </Box>
    ),
    []
  );

  const Registration = React.useMemo(() => <RegitrationForm />, []);
  const Authentication = React.useMemo(() => <LoginForm />, []);

  return (
    <div style={{ padding: '2rem' }}>
      {type === 'login'
        ? Authentication
        : type === 'register'
        ? Registration
        : Menu}
    </div>
  );
};

export default React.memo(RegisterOrLoginMenu);
